exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".van-cell__value[data-v-7c55efa8]{overflow:hidden}.van-cell-group[data-v-7c55efa8]{margin-top:.4rem}.van-button[data-v-7c55efa8]{display:block;width:90%;margin:5% auto}", ""]);

// exports
